export default "__VITE_ASSET__CavnKCaj__"